import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import ButtonGroupProps from './ButtonGroupProps'


export default {
    props: ButtonGroupProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoButtonGroup(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoButtonGroup()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButtonGroup/KendoButtonGroupMixin.js